<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="打印入库单"
      width="1000px"
      class="printStorageOrder">
    <div id="content" :loading="contentLoading">
      <div v-for="(item,index) in inStockBill" :key="index" class="inStockOrderItem">
        <table class="codeBox" cellspacing="0">
          <tr>
            <td rowspan="3" class="imgBox">
              <div :id="'qrCode'+item.billNo" align="center"/>
            </td>
            <td colspan="5" style="text-align:center;font-weight:700">入库单</td>
          </tr>
          <tr>
            <td colspan="2">入库单号：{{item.billNo}}</td>
            <td colspan="2">入库类型：{{item.inStockTypeName}}</td>
            <td colspan="2">收货时间：{{item.requireDate}}</td>
          </tr>
          <tr>
            <td colspan="2">关联单号：{{item.relBillNo}}</td>
            <td colspan="4">备注：{{item.note}}</td>
          </tr>
        </table>
        <el-table :data="item.details" border style="width: 100%">
          <el-table-column prop="materialNo" label="物料编号" width="150"/>
          <el-table-column prop="materialName" label="物料名称"/>
          <el-table-column prop="unitName" label="单位" align="center" width="80"/>
          <el-table-column prop="quantity" label="数量" align="center" width="80"/>
          <el-table-column prop="locationName" label="库位" align="center" width="120"/>
          <el-table-column prop="note" label="备注" width="120" show-overflow-tooltip/>
        </el-table>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="print">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import QRCode from "qrcodejs2";
  export default {
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        inStockBill:[{
          billNo:"",
          inStockTypeName:"",
          requireDate:"",
          relBillNo:"",
          note:"",
          details:[],
        }],

      };
    },

    methods: {
      open(ids) {
        this.dialogVisible = true;
        this.getData(ids);
      },
      getData(ids) {
        this.$http
          .get("basic", `inStockBills/getAllListByIds/${ids}`)
          .then(resp => {
            console.log(resp);
            this.inStockBill = resp.data;
            for (let item of this.inStockBill) {
              this.$nextTick(() => {
                document.getElementById("qrCode" + item.billNo).innerHTML = "";
                this.bindQRCode(item.billNo);
              });
            }
          });
      },
      bindQRCode(billNo) {
        let text = billNo;
        new QRCode(document.getElementById("qrCode" + billNo), {
          text: text,
          width: 120,
          height: 120,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      },
      print() {
        document.body.innerHTML = document.getElementById("content").parentNode.innerHTML;
        window.print();
        window.location.reload();
        return false;
      },
    },
  };
</script>

<style scoped>
.inStockOrderItem {
  margin-bottom:20px;
}
.codeBox {
  width: 100%;
  height: 150px;
  margin-bottom: 5px;
}

.codeBox td {
  border: 1px solid #ebeef5;
  border-right: 0;
  border-top: 0;
  padding:0 5px;
}

.codeBox tr td:last-child {
  border-right: 1px solid #ebeef5;
}

.codeBox tr:first-child td {
  border-top: 1px solid #ebeef5;
}

.imgBox {
  width: 150px;
  padding: 10px;
  box-sizing: border-box;
}
.imgBox img {
  width: 100%;
  height: 100%;
}
</style>

<style>
.printStorageOrder .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}
.printStorageOrder .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.printStorageOrder .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.printStorageOrder .el-divider--horizontal {
  margin: 10px 0;
}

.printStorageOrder .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}
</style>